import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=782da4bd&"
import script from "./messages.vue?vue&type=script&lang=ts&"
export * from "./messages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "messages.vue"
export default component.exports